/**
 * ReconTotals — onglet « Totaux » : nombre et montants (retraits · dépôts · net) par état de rapprochement au `recon_date`,
 * + rappel des soldes régularisés et de l'écart.
 */
import { money } from "../../comptabilite/_shared";
import { STATE_PILL } from "./ReconRegister";

export default function ReconTotals({ summary }) {
  if (!summary) return null;
  const t = summary.totals || {};
  const rows = Object.keys(STATE_PILL).map((k) => ({ k, label: STATE_PILL[k][0], ...(t[k] || { count: 0, withdrawals: 0, deposits: 0, variance: 0 }) }));
  const all = rows.reduce((a, r) => ({ count: a.count + r.count, withdrawals: a.withdrawals + r.withdrawals, deposits: a.deposits + r.deposits }), { count: 0, withdrawals: 0, deposits: 0 });
  const st = summary.statement, lg = summary.ledger;
  return (
    <div className="space-y-4" data-testid="recon-totals">
      <div className="bg-white border rounded-xl overflow-hidden">
        <div className="px-3 py-2 text-xs font-semibold text-slate-600 border-b">Transactions du compte par état — au {summary.as_of}</div>
        <table className="w-full text-sm" data-testid="recon-totals-table">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500">
            <tr><th className="text-left px-3 py-2">État-Rapprochement</th><th className="text-right px-3 py-2">Nombre</th><th className="text-right px-3 py-2">Retraits</th><th className="text-right px-3 py-2">Dépôts</th><th className="text-right px-3 py-2">Net</th><th className="text-right px-3 py-2">Écarts compensés</th></tr>
          </thead>
          <tbody className="divide-y">
            {rows.map((r) => (
              <tr key={r.k} data-testid={`recon-totals-${r.k}`}>
                <td className="px-3 py-2"><span className={`inline-block text-xs px-2 py-0.5 rounded-full border ${STATE_PILL[r.k][1]}`}>{r.label}</span></td>
                <td className="px-3 py-2 text-right font-mono">{r.count}</td>
                <td className="px-3 py-2 text-right font-mono text-rose-700">{money(r.withdrawals)}</td>
                <td className="px-3 py-2 text-right font-mono text-emerald-700">{money(r.deposits)}</td>
                <td className="px-3 py-2 text-right font-mono font-semibold">{money(r.deposits - r.withdrawals)}</td>
                <td className="px-3 py-2 text-right font-mono text-slate-500">{Math.abs(r.variance) >= 0.005 ? money(r.variance) : "—"}</td>
              </tr>
            ))}
          </tbody>
          <tfoot className="bg-slate-50 font-semibold">
            <tr data-testid="recon-totals-all"><td className="px-3 py-2">Total</td><td className="px-3 py-2 text-right font-mono">{all.count}</td><td className="px-3 py-2 text-right font-mono text-rose-700">{money(all.withdrawals)}</td><td className="px-3 py-2 text-right font-mono text-emerald-700">{money(all.deposits)}</td><td className="px-3 py-2 text-right font-mono">{money(all.deposits - all.withdrawals)}</td><td></td></tr>
          </tfoot>
        </table>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
        {[["Solde du relevé régularisé", st.adjusted, "recon-totals-adj-statement"], ["Solde comptable régularisé", lg.adjusted, "recon-totals-adj-gl"], ["Lignes de relevé non comptabilisées", summary.unmatched_bank_lines?.total, "recon-totals-unmatched"], ["Écart", summary.difference, "recon-totals-difference"]].map(([label, v, tid]) => (
          <div key={tid} className="bg-white border rounded-xl p-3" data-testid={tid}>
            <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
            <div className={`font-mono font-bold mt-0.5 ${tid === "recon-totals-difference" ? (v === null || v === undefined ? "text-slate-500" : Math.abs(v) < 0.005 ? "text-emerald-700" : "text-rose-700") : "text-slate-900"}`}>{v === null || v === undefined ? "—" : money(v)}</div>
            {tid === "recon-totals-unmatched" && <div className="text-[10px] text-slate-400">{summary.unmatched_bank_lines?.count || 0} ligne(s)</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
